export const NEW_SCHEDULED_EMAIL_ADDED_TEXT = {
    id: 'oe.websiteTab.newScheduledEmailAdded',
    defaultMessage: 'New scheduled email added',
    description: 'Notification message',
};

export const SCHEDULED_EMAIL_UPDATED_TEXT = {
    id: 'oe.websiteTab.scheduledEmailUpdated',
    defaultMessage: 'Scheduled email updated',
    description: 'Notification message',
};

export const EMAIL_NAME_INTERNAL_TEXT = {
    id: 'oe.websiteTab.emailNameInternal',
    description: 'Label text',
    defaultMessage: 'Email Name (Internal)'
};

export const EMAIL_SUBJECT_TEXT = {
    id: 'oe.label.emailSubject',
    description: 'Label text',
    defaultMessage: 'Email Subject'
};

export const EMAIL_BODY_TEXT = {
    id: 'oe.label.emailBody',
    description: 'Label text',
    defaultMessage: 'Email Body'
};

export const EMAIL_IS_BEING_SAVED_TEXT = {
    id: 'oe.websiteTab.emailIsBeingSaved',
    description: 'Placeholder about saving email',
    defaultMessage: 'Email is being saved, please wait...',
};

export const MEETING_TIME_TEXT = {
    id: 'oe.meeting.time',
    defaultMessage: 'Time',
    description: 'Label text',
};

export const EMAIL_SUBJECT_TOO_LONG_ERROR_TEXT = {
    description: 'Warning message',
    defaultMessage: 'Email subject is too long',
    id: 'oe.common.emailSubjectTooLong',
};

export const EMAIL_SUBJECT_REQUIRED_ERROR_TEXT = {
    description: 'Warning message',
    defaultMessage: 'Email subject is required',
    id: 'oe.common.emailSubjectRequired',
};

export const EMAIL_BODY_TOO_LONG_ERROR_TEXT = {
    description: 'Warning message',
    defaultMessage: 'Email body is too long',
    id: 'oe.common.emailBodyTooLong',
};

export const EMAIL_BODY_REQUIRED_ERROR_TEXT = {
    description: 'Warning message',
    defaultMessage: 'Email body is required',
    id: 'oe.common.emailBodyRequired',
};

export const SHORT_PLAIN_TEXT_TOO_LONG_ERROR_TEXT = {
    id: `oe.validation.shortPlainTextTooLong`,
    defaultMessage: 'Too long - max length is 255 characters',
    description: 'Error message text'
};

export const LONG_PLAIN_TEXT_TOO_LONG_ERROR_TEXT = {
    id: `oe.validation.longPlainTextTooLong`,
    defaultMessage: 'Too long - max length is 4096 characters',
    description: 'Error message text'
};

export const DATE_AND_TIME_IS_REQUIRED_ERROR_TEXT = {
    description: 'Warning message',
    defaultMessage: 'Date is required',
    id: 'oe.common.dateAndTimeIsRequired'
};

export const INVALID_TIME_ERROR_TEXT = {
    id: 'oe.common.invalidTime',
    defaultMessage: 'Invalid Time',
    description: 'Validation error message',
};

export const DATE_AND_TIME_SHOULD_NOT_BE_IN_THE_PAST_ERROR_TEXT = {
    description: 'Warning message',
    defaultMessage: 'Date and time should not be in the past',
    id: 'oe.websiteTab.dateAndTimeShouldNotBeInThePast',
};

export const SCHEDULED_MEETING_NOTIFICATION_TEXT = {
    description: 'Label field',
    message: 'Sending notification is {suffix}',
    id: 'oe.websiteTab.scheduledMeetingNotification',
};

export const NOTIFICATION_ENABLED_INFO_MESSAGE_TEXT = {
    description: 'Label field',
    defaultMessage: `If enabled, 2 hours before the scheduled sending time, a notification email will be sent
     to all Project Managers and Co-Project Managers, warning them that the email will be sent to attendees.
     This provides a final fail-safe opportunity for the PM to edit or cancel the email before it is sent.`,
    id: 'oe.websiteTab.notificationEnabledInfoMessage',
};

export const TO_PREVIEW_EMAIL_SAVE_IT_FIRST = {
    description: 'Label field',
    defaultMessage: 'You will be able to Preview the email once it is saved.',
    id: 'oe.websiteTab.toPreviewEmailSaveItFirst',
};
